import axios from "axios";
import { ActionType } from "../action-types";
import { OperatorDto } from "../../dto/postLogin";
import { http } from "../../utils/http";
import { AppThunk } from "./types";

export const setOperators = (items: OperatorDto[]) => ({
  type: ActionType.SET_OPERATORS,
  payload: items,
});

export const setOperatorsLoading = (isLoading: boolean) => ({
  type: ActionType.SET_OPERATORS_LOADING,
  payload: isLoading,
});

export const resetOperators = () => ({
  type: ActionType.RESET_OPERATORS,
});

export const fetchOperators = (): AppThunk<Promise<void>> => {
  return async (dispatch, getState) => {
    const jwt = getState().token;
    if (!jwt) throw new Error("Missing JWT!");

    dispatch(setOperatorsLoading(true));

    try {
      const res = await http.get("/api/Operators");
      const data = res.data;
      const operators: OperatorDto[] = data.operators ?? [];

      dispatch(setOperators(operators));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status ?? "NO_STATUS";
        const text =
          typeof error.response?.data === "string"
            ? error.response.data
            : JSON.stringify(error.response?.data ?? "");
        throw new Error(`GET /api/Operators failed REQUEST: ${status} ${text}`);
      }
      throw error;
    } finally {
      dispatch(setOperatorsLoading(false));
    }
  };
};
